import { validationMessage } from 'vuelidate-messages'
import { messages } from '@/lib/validation-helpers'
import { required, requiredIf } from 'vuelidate/lib/validators'

export const validations = {
  validations: {
    payload: {
      entity_id: {
        required: requiredIf(payload => payload.entity)
      },
      state_id: {
        required: requiredIf(payload => payload.in_kanban)
      }
    }
  },

  methods: {
    $v_displayMessage: validationMessage(messages)
  }
}
